// Uploads go through our own backend, which holds the storage credentials.
// Nothing AWS-related is bundled into the browser any more.
import { API_BASE_URL } from './config';
import { getToken } from './session';

/**
 * Send a file to the backend and return the URL to store against the record.
 *
 * @param file       the File chosen by the user
 * @param onProgress optional callback receiving 0-100
 * @param purpose    'services' for catalogue photos (publicly viewable),
 *                   'staff-docs' or 'vendor-docs' for documents (sign-in required)
 */
export const uploadFile = (file, onProgress, purpose = 'services') =>
  new Promise((resolve, reject) => {
    const form = new FormData();
    form.append('file', file);
    form.append('purpose', normalisePurpose(purpose));

    const request = new XMLHttpRequest();
    request.open('POST', `${API_BASE_URL}/upload/`);

    const token = getToken();
    if (token) request.setRequestHeader('Authorization', `Bearer ${token}`);

    request.upload.onprogress = (event) => {
      if (onProgress && event.lengthComputable) {
        onProgress(Math.round((event.loaded * 100) / event.total));
      }
    };

    request.onload = () => {
      let body = {};
      try {
        body = JSON.parse(request.responseText);
      } catch (error) {
        /* fall through to the generic message below */
      }
      if (request.status >= 200 && request.status < 300 && body.url) {
        resolve(body.url);
      } else {
        const message = body.error || 'Upload failed. Please try again.';
        reject(new Error(message));
      }
    };

    request.onerror = () => {
      reject(new Error('Network error during upload'));
    };

    request.send(form);
  });

// Older callers passed a folder path like '/staff/aadhar'; map those onto the
// two kinds of storage the backend understands.
function normalisePurpose(purpose) {
  const value = String(purpose || '').toLowerCase();
  if (value.includes('staff')) return 'staff-docs';
  if (value.includes('vendor')) return 'vendor-docs';
  if (value === 'services' || value === 'staff-docs' || value === 'vendor-docs') return value;
  return 'services';
}
